import { section } from '@/glow';
import Carousel from '@/lib/carousel';

section('featured-collection', {
  onLoad() {
    const carouselWraps = this.container.dataset.carouselWraps === 'true';
    this.carousel = Carousel(this.container, 'featured-collection', {
      wrapAround: carouselWraps,
    });
  },

  onUnload() {
    this.carousel.destroy();
  },
});
